define('view/controller/gdpr-report/GdprReportMainView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     *
     *
     * @class GdprReportMainView
     */
    return LayoutView.extend({

        template: '#gdpr_report_main_view',

        PAGE_SIZE: 10,

        ui: {
            'confirmationBtn': '#sb_gdpr_report_show_confirmation'
        },

        events: {
            'click @ui.confirmationBtn': '_onClickConfirmationBtn',
            'click .gdpr-pager a[data-page]': '_onPaginationClick',
            'shown.bs.collapse .table-wrapper': '_onSectionShown',
            'hidden.bs.collapse .table-wrapper': '_onSectionHidden'
        },

        modelEvents: {
            'change': 'render'
        },

        imageKeys : ['picture_path', 'image'],
        urlKeysPart : ['_path', 'url', 'domain', 'link'],

        initialize: function (options) {
            this._pages = {};
            this._loadingKeys = {};
            this._openIds = {};
        },

        MAX_PAGE_LINKS: 7,

        _onPaginationClick: function (e) {
            e.preventDefault();

            var inst = this;
            var $target = jQuery(e.currentTarget);
            var reportKey = $target.closest('.gdpr-pager').data('report-key');
            var page = parseInt($target.data('page'), 10);

            if (!reportKey || !page || this._loadingKeys[reportKey]) {
                return;
            }

            this._loadingKeys[reportKey] = true;

            jQuery.get('/v2/gdpr-report/page', {key: reportKey, page: page})
                .done(function (response) {
                    if (!response || response.key !== reportKey) {
                        return;
                    }

                    inst._pages[reportKey] = response.page;

                    var attrs = {};
                    attrs[reportKey] = response.data;
                    attrs[reportKey + '_total'] = response.total_rows_count;
                    inst.model.set(attrs);
                })
                .fail(function (xhr) {
                    if (xhr && xhr.status === 403) {
                        inst._onSessionExpired();
                    }
                })
                .always(function () {
                    delete inst._loadingKeys[reportKey];
                });
        },

        // report session timed out on the server: drop loaded data and ask to confirm identity again
        _onSessionExpired: function () {
            var isLoggedIn = this.model.get('is_logged_in');
            // visitor identified by email/phone: drop id so the confirmation popup asks for them
            // instead of auto-submitting an empty request
            var keep = {id: isLoggedIn ? this.model.get('id') : null, is_logged_in: isLoggedIn};

            this._sessionExpired = true;
            this._pages = {};
            this._openIds = {};
            this.model.clear({silent: true});
            keep.code_confirmed = false;
            this.model.set(keep);
        },

        // builds pagination metadata for a report-type key already fetched server-side (one page at a time)
        _buildPagination: function (key, total) {
            var pageSize = this.PAGE_SIZE;
            var totalPages = Math.max(1, Math.ceil(total / pageSize));
            var currentPage = Math.min(this._pages[key] || 1, totalPages);

            this._pages[key] = currentPage;

            // cap the number of page-number links shown (e.g. 45 pages would otherwise
            // overflow the table width) - keep a sliding window around the current page
            var maxLinks = this.MAX_PAGE_LINKS;
            var windowStart = Math.max(1, currentPage - Math.floor(maxLinks / 2));
            var windowEnd = Math.min(totalPages, windowStart + maxLinks - 1);
            windowStart = Math.max(1, windowEnd - maxLinks + 1);

            return {
                key: key,
                currentPage: currentPage,
                totalPages: totalPages,
                prevPage: currentPage - 1,
                nextPage: currentPage + 1,
                windowStart: windowStart,
                windowEnd: windowEnd
            };
        },

        onRender: function () {
            if (this.model.get('id') && !this.model.get('code_confirmed')) {
                // notify controller to ask for confirmation code
                this.triggerMethod('confirmation_required');
            }

            if (this._sessionExpired) {
                this._sessionExpired = false;
                jQuery('<div class="alert alert-warning" role="alert"></div>')
                    .text(Locale.get('gdpr_report_session_expired'))
                    .prependTo(this.$('.main-gdpr-report'));
            }

            // render() rebuilds the DOM, so re-open the sections that were open (no animation)
            var inst = this;
            _.each(_.keys(this._openIds), function (id) {
                var $wrapper = inst.$('#' + id);

                if ($wrapper.length) {
                    $wrapper.addClass('in');
                    inst.$('[data-toggle="collapse"][href="#' + id + '"]')
                        .removeClass('collapsed').attr('aria-expanded', 'true');
                }
            });
        },

        // open sections are tracked continuously (bootstrap collapse events), not at click time,
        // so overlapping page requests cannot lose the state
        _onSectionShown: function (e) {
            if (e.target.id) {
                this._openIds[e.target.id] = true;
            }
        },

        _onSectionHidden: function (e) {
            if (e.target.id) {
                delete this._openIds[e.target.id];
            }
        },

        _onClickConfirmationBtn: function () {
            this.triggerMethod('confirmation_required');
            return false;
        },

        convFunc : function (str) {
            if(str && _.isString(str)) {
                 str = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            }
            return str;
        },

        escapeHtml : function(str) {
            //console.log(str);
            var inst = this;
            var allowedTags = ['&emsp;', '&nbsp;', '<br>', '<b>', '</b>','<p>', '</p>', '<strong>', '</strong>'];

            if(str) {
                str = this.convFunc(str);
                jQuery.each(allowedTags, function(n, tag){
                    var convTag = inst.convFunc(tag);
                    var reg = new RegExp(convTag,"g");
                    //console.log(str);
                    if(str && _.isString(str)) {
                        str = str.replace(reg, tag);
                    }
                });
                return str;
            }
            return '-';
        },

        serializeData: function () {
            var inst = this;
            var result = $.extend(true, {}, Marionette.ItemView.prototype.serializeData.apply(this));
            var newResult = {};
            // every key that turns out to hold report-row data (as opposed to a page flag like
            // id/code_confirmed/is_logged_in) - main_view.tpl loops this instead of hardcoding
            // one partial-invocation line per report key
            var dataKeys = [];

            _.each(result, function(value, key){
                if (/_total$/.test(key)) {
                    return; // consumed together with its report key below, not a table of its own
                }

                //if(value && _.isArray(value)) {
                newResult[key] = value;
                //}
                if(value && !_.isArray(value) && _.isObject(value)) {
                    newResult[key] = [value];
                }

                if(_.isArray(newResult[key])) {
                    dataKeys.push(key);

                    _.each(newResult[key], function (row, num) {
                        _.each(row, function (itemValue, itemKey) {

                            if(itemValue) {
                                newResult[key][num][itemKey] = itemValue = inst.escapeHtml(itemValue);
                            }

                            if(!_.isEmpty(itemValue) && inst.imageKeys.indexOf(itemKey) >= 0){
                                newResult[key][num][itemKey] = '<img src="'+itemValue+'" alt="" /><br><small>'+itemValue+'</small>';
                            } else
                            if(!_.isEmpty(itemValue) && itemKey.indexOf("email") >= 0){
                                newResult[key][num][itemKey] = '<a href="mailto:'+itemValue+'">'+itemValue+'</a>';
                            } else {
                                var isUrl = false;
                                _.each(inst.urlKeysPart, function (urlKeyPath) {
                                    if(!_.isEmpty(itemValue) && itemKey.indexOf(urlKeyPath) >= 0){
                                        isUrl = true;
                                    }
                                });

                                if(isUrl){
                                    newResult[key][num][itemKey] = '<a href="'+itemValue+'">'+itemValue+'</a>';
                                }
                            }
                        });
                    });

                    if (!inst._printMode && result[key + '_total'] !== undefined) {
                        newResult[key + '_pagination'] = inst._buildPagination(key, result[key + '_total']);
                    }
                }

            });

            newResult.data_keys = dataKeys;

            return newResult;
        },

        // print needs every row, not just the page shown on screen: load the full report,
        // render it, print, then go back to the paginated view
        onPrintReport : function () {
            var inst = this;

            if (this._printMode) {
                return;
            }

            jQuery('body').addClass('report-page');

            jQuery.get('/v2/gdpr-report/info', {full: 1})
                .done(function (response) {
                    if (!response || !response.code_confirmed) {
                        inst.model.set(response || {});
                        return;
                    }

                    inst._printMode = true;
                    // the model keeps *_total keys of the paginated load; they are ignored in print mode
                    inst.model.set(response);
                    inst.render();

                    var restore = _.once(function () {
                        jQuery(window).off('afterprint.gdprprint');
                        clearTimeout(inst._printRestoreTimer);
                        inst._restorePaginatedView();
                    });

                    jQuery(window).on('afterprint.gdprprint', restore);
                    // fallback for browsers that do not fire afterprint
                    inst._printRestoreTimer = setTimeout(restore, 30000);

                    window.print();
                })
                .fail(function () {
                    // could not load full data - print what is on screen
                    window.print();
                });
        },

        _restorePaginatedView: function () {
            var inst = this;

            this._printMode = false;
            this._pages = {};

            this.model.fetch({silent: true}).always(function () {
                if (!inst.isDestroyed) {
                    inst.render();
                }
            });
        },

        onJsonReport : function () {
            window.location.href = "/v2/gdpr-report/json";
        }

    });

});

